import React, { useEffect } from 'react';
import _ from 'lodash';
import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import {
  Button,
  DatePicker,
  Select,
  TextField,
} from '@bld/bld-libs/components';

import { useFieldBulletinBoards } from '../../services/fieldBulletinBoard/FieldBulletinBoardsContext';
import LocalStorageService from '../../services/utilities/LocalStorageService';

import { messageUtility } from '../../utilities/messageUtility';
import { isPartnerCompanyRoleId } from '../../utilities/roleUtility';
import {
  deleteControlCode,
  trimAndRemoveLineBreak,
} from '../../utilities/stringUtil';
import {
  PUBLICATION_STATUS_LIST,
  IMPORTANCE_TYPE,
} from '../../utilities/constants';

export function FieldBulletinBoardsSearchHeader(props) {
  const {
    defaultSearchParam,
    getSearchParam,
    inputTitle,
    selectBulletinBoardPublicationStatus,
    searchFieldBulletinBoardList,
    setPublicationStartAtFrom,
    adjustmentPublicationDateAtFrom,
    setPublicationStartAtTo,
    adjustmentPublicationDateAtTo,
    setSearchParam,
    setFixedSearchParam,
    setImportanceType,
    setUnreadOnly
  } = useFieldBulletinBoards();

  useEffect(() => {
    const { initSearchParam } = props;
    const searchParam = _.isEmpty(initSearchParam)
      ? defaultSearchParam
      : initSearchParam;

    setSearchParam(searchParam);
    setFixedSearchParam(searchParam);
  }, []);

  const searchParam = getSearchParam();

  const roleId = LocalStorageService.getRoleId();

  return (
    <Paper sx={{ margin: '16px' }} elevation={1}>
      <Grid container>
        <Grid item xs='auto'>
          <Stack direction='column' spacing={2}>
            <Box>
              <Stack
                direction='row'
                spacing={2}
                justifyContent='flex-start'
                sx={{ padding: '16px' }}
              >
                <TextField
                  label={messageUtility.getMessage('I-000-164-04')}
                  placeholder={messageUtility.getMessage('I-000-164-17')}
                  value={searchParam.title}
                  onChange={event => inputTitle(event.target.value)}
                  inputProps={{ maxLength: 64 }}
                  width='210px'
                  onBlur={event =>
                    inputTitle(
                      trimAndRemoveLineBreak(
                        deleteControlCode(event.target.value)
                      )
                    )
                  }
                  sx={{
                    '& .MuiInputBase-root, & .MuiInputBase-input': {
                      height: '46px',
                      borderRadius: '8px',
                    },
                  }}
                />
                {/* 協力会社ユーザーの場合は非表示 */}
                {!isPartnerCompanyRoleId(roleId) && (
                  <Select
                    label={messageUtility.getMessage('I-000-164-05')}
                    options={PUBLICATION_STATUS_LIST}
                    value={searchParam.bulletin_board_publication_status}
                    onChange={event =>
                      selectBulletinBoardPublicationStatus(event.value)
                    }
                    width='150px'
                    sx={{ height: '46px', borderRadius: '8px' }}
                  />
                )}
                <Stack direction='row' spacing={1} alignItems='center'>
                  <Typography sx={{ fontSize: '14px' }}>
                    {messageUtility.getMessage('I-000-164-06')}
                  </Typography>
                  <DatePicker
                    value={searchParam.publication_start_at_from}
                    onChange={setPublicationStartAtFrom}
                    onBlur={adjustmentPublicationDateAtFrom}
                  />
                  <Typography sx={{ fontSize: '14px' }}>~</Typography>
                  <DatePicker
                    value={searchParam.publication_start_at_to}
                    onChange={setPublicationStartAtTo}
                    onBlur={adjustmentPublicationDateAtTo}
                  />
                </Stack>
              </Stack>
            </Box>
            <Stack 
              direction='row'
              spacing={2}
              sx={{ marginTop: '0px !important' }}
              >
              <FormControlLabel
                control={
                  <Checkbox
                    color='secondary'
                    checked={
                      getSearchParam().importance_type === IMPORTANCE_TYPE.CHECK
                    }
                    onChange={setImportanceType}
                  />
                }
                label={messageUtility.getMessage('I-000-164-07')}
                sx={theme => ({
                  paddingLeft: '4px',
                  '&& svg.MuiSvgIcon-root': { fill: theme.palette.primary.main },
                })}
              />
              {isPartnerCompanyRoleId(roleId) && (
                <FormControlLabel
                  control={
                    <Checkbox
                      color='secondary'
                      checked={
                        getSearchParam().unread_only
                      }
                      onChange={setUnreadOnly}
                    />
                  }
                  label={messageUtility.getMessage('I-000-164-08')}
                  sx={theme => ({
                    paddingLeft: '4px',
                    marginLeft: '0px !important',
                    '&& svg.MuiSvgIcon-root': { fill: theme.palette.primary.main },
                  })}
                />
              )}
            </Stack>
          </Stack>
        </Grid>
        <Grid container item xl='auto' justifyContent={'flex-end'}>
          <Stack
            direction='row'
            spacing={2}
            alignItems='center'
            sx={{ padding: '16px', marginTop: '-50px' }}
          >
            <Button
              variant='contained'
              color='primary'
              onClick={() => searchFieldBulletinBoardList()}
              sx={{ width: '104px', height: '41px' }}
            >
              {messageUtility.getMessage('I-000-164-09')}
            </Button>
            <Button
              variant='outlined'
              color='primary'
              onClick={() => searchFieldBulletinBoardList(true)}
              sx={{ width: '104px', height: '41px' }}
            >
              {messageUtility.getMessage('I-000-164-10')}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardsSearchHeader.jsx